import { User } from '../main'

interface ProfilePageProps {
  user?: User
}

export function ProfilePage({ user }: ProfilePageProps) {
  return (
    <div className="page">
      <div className="container">
        <div className="hero">
          <h1>Citizen Profile</h1>
          <p className="hero-subtitle">
            Manage your identity across the SWGRealms universe
          </p>
        </div>

        {/* Current Profile Info */}
        <div className="swg-window mb-lg">
          <div className="swg-window-header">
            <h3>Imperial Registry - Citizen Record</h3>
          </div>
          <div className="swg-window-content">
            <div className="status-indicator status-online mb-md">
              <span>●</span> Registry Status: Active
            </div>
            
            <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: 'var(--swg-spacing-md)'}}>
              <div>
                <small>Current Identity</small>
                <div style={{fontSize: '1.1rem', fontWeight: 'bold', marginTop: '0.25rem'}}>{user?.username || 'Guest'}</div>
              </div>
              <div>
                <small>Communication Channel</small>
                <div style={{fontSize: '1.1rem', marginTop: '0.25rem'}}>{user?.email || 'Not available'}</div>
              </div>
              <div>
                <small>Legacy Designation</small>
                <div style={{fontSize: '1.1rem', marginTop: '0.25rem'}}>
                  {user?.legacy_name || 'Not specified'}
                </div>
              </div>
              <div>
                <small>Verification Status</small>
                <div style={{fontSize: '1.1rem', marginTop: '0.25rem'}}>
                  {user?.verified ? (
                    <span className="status-indicator status-online" style={{fontSize: '0.9rem'}}>
                      <span>●</span> Verified Veteran
                    </span>
                  ) : (
                    <span className="status-indicator status-warning" style={{fontSize: '0.9rem'}}>
                      <span>●</span> Pending Verification
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Under Construction Sections */}
        <div className="dashboard-grid">
          <div className="swg-window">
            <div className="swg-window-header">
              <h3>Personal Customization Module</h3>
            </div>
            <div className="swg-window-content">
              <div className="status-indicator status-warning mb-md">
                <span>●</span> Awaiting Security Clearance
              </div>
              <p className="mb-md" style={{fontSize: '0.9rem'}}>
                The <strong>Personal Identity Customization Interface</strong> is currently under review 
                by the Imperial Security Bureau.
              </p>
              <div style={{fontSize: '0.8rem', color: 'var(--swg-text-secondary)'}}>
                <div className="mb-sm">• Avatar appearance settings</div>
                <div className="mb-sm">• Display name preferences</div>
                <div className="mb-sm">• Bio and personal history</div>
                <div className="mb-sm">• Privacy controls</div>
              </div>
              <div className="progress-bar mt-md">
                <div className="progress-fill action" style={{width: '45%'}}></div>
                <div className="progress-text">Security Review: 45%</div>
              </div>
            </div>
          </div>

          <div className="swg-window">
            <div className="swg-window-header">
              <h3>Galactic Preferences</h3>
            </div>
            <div className="swg-window-content">
              <div className="status-indicator status-offline mb-md">
                <span>●</span> Pending Form 19-C Processing
              </div>
              <p className="mb-md" style={{fontSize: '0.9rem'}}>
                Your gameplay preferences and galaxy matching criteria require additional 
                documentation per Imperial Regulation 847-J.
              </p>
              <div style={{fontSize: '0.8rem', color: 'var(--swg-text-secondary)'}}>
                <div className="mb-sm">• Preferred playstyle settings</div>
                <div className="mb-sm">• Community interaction preferences</div>
                <div className="mb-sm">• Galaxy recommendation algorithm</div>
                <div className="mb-sm">• Notification preferences</div>
              </div>
              <p style={{fontSize: '0.7rem', fontStyle: 'italic', marginTop: 'var(--swg-spacing-md)'}}>
                "Form 19-C processing typically requires 1-2 business rotations, 
                excluding Imperial holidays and mandatory loyalty celebrations."
              </p>
            </div>
          </div>

          <div className="swg-window">
            <div className="swg-window-header">
              <h3>Achievement Archive</h3>
            </div>
            <div className="swg-window-content">
              <div className="status-indicator status-warning mb-md">
                <span>●</span> Historical Data Reconstruction in Progress
              </div>
              <p className="mb-md" style={{fontSize: '0.9rem'}}>
                The Imperial Archives Department is currently reconstructing historical 
                achievement data from the Great Database Migration of 2011.
              </p>
              <div style={{fontSize: '0.8rem', color: 'var(--swg-text-secondary)'}}>
                <div className="mb-sm">• Legacy SWG accomplishments</div>
                <div className="mb-sm">• Cross-galaxy achievements</div>
                <div className="mb-sm">• Community contributions</div>
                <div className="mb-sm">• Veteran status recognition</div>
              </div>
              <div className="progress-bar mt-md">
                <div className="progress-fill health" style={{width: '12%'}}></div>
                <div className="progress-text">Data Recovery: 12%</div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-xl">
          <div className="swg-window">
            <div className="swg-window-header">
              <h3>Imperial Disclaimer</h3>
            </div>
            <div className="swg-window-content">
              <p style={{fontSize: '0.8rem', color: 'var(--swg-text-secondary)', fontStyle: 'italic'}}>
                "The Empire appreciates your patience as we implement these essential citizen services. 
                Rest assured that our commitment to bureaucratic excellence ensures that when these 
                features are deployed, they will meet the highest standards of Imperial efficiency. 
                Any complaints regarding processing delays should be submitted via Form 66-Z to the 
                Department of Citizen Satisfaction, Sub-Committee for Delayed Gratification."
              </p>
              <p style={{fontSize: '0.7rem', marginTop: 'var(--swg-spacing-sm)', textAlign: 'right'}}>
                - <em>Imperial Public Relations Division</em>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
